const indexInit = {
    
}
const gift = (state = indexInit, action) => {
    switch (action.type) {
      case "GIFT_LST":
        return Object.assign({}, state, {
          ...action
        });
      default:
        return state;
    }
}

export default gift